export default __webpack_public_path__ + "static/banking_insurance-5cf4389deb643a2879023a30a6d8f9b2.png";